import HFUsage from './model';
import OnlineUsage from './onlineUsage';
import { List } from 'immutable';

const reviver = ([key, val]) => {
  switch (key) {
    case 'studentId':
    case 'gainedDiamonds':
    case 'totalDiamonds':
      return [key, `${val}`];
    case 'onlineUsages': {
      if (val && val.map) {
        return [key, val.map((item) => OnlineUsage.create(item))];
      }
      return [key, new List()];
    }
    default:
      return [key, val];
  }
};

const create = (data) =>
  new HFUsage(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/OnlineHomework/HFUsage/model/create.js